import { useEffect, useState } from 'react';

/**
 * Generic permission hook
 *
 * @param {string | null} key - Cache key (e.g. 'incidence.create')
 * @param {() => Promise<{allowed: boolean}>} fetcher
 */
export function usePermission(key, fetcher) {
    const [allowed, setAllowed] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!key) return;

        const ac = new AbortController();
        setLoading(true);

        fetcher(ac.signal)
            .then(r => setAllowed(Boolean(r.allowed)))
            .catch(e => {
                if (e.name !== 'AbortError') setAllowed(false);
            })
            .finally(() => setLoading(false));

        return () => ac.abort();
    }, [key]);

    return { allowed, loading };
}
